'use strict';

var processInclude = require('@sfra/util');

$(document).ready(function () {
    processInclude(require('./product/detail'));
    processInclude(require('./product/quickView'));
    processInclude(require('./product/productTileBadges'));
    processInclude(require('@plugin_wishlists/product/wishlist'));
});
